/**
 * The app's one scroll container.
 *
 * The window itself does not scroll — the sidebar and the top bar are fixed
 * chrome — so anything that used to move `window` has to move this element
 * instead. It lives in App.tsx, below the top bar; addressed by id rather than
 * through a ref so non-React callers can reach it too.
 *
 * Absent on any page that renders outside the app layout, hence the optional
 * chaining at every call site.
 */
export const APP_SCROLL_ID = "app-scroll";

export const appScrollElement = (): HTMLElement | null =>
  typeof document === "undefined" ? null : document.getElementById(APP_SCROLL_ID);
